var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AsiContentContainer',{attrs:{"columns":3,"columns-lg":4,"columns-xl":5,"with-row-gap":"","small-row-gap":"","small-column-gap":"","no-margin":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }